import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 0,
  style: {"font-size":"0.9em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
    width: "800"
  }, {
    activator: _withCtx(({}) => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "primary",
                onClick: _ctx.open
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.dialog.button')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-flex justify-end",
            style: {"padding-right":"100px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: _ctx.locale === 'fr' ? 'https://vetdata.ch/fr/pricing' : 'https://vetdata.ch/pricing/',
                target: "_blank"
              }, _toDisplayString(_ctx.$t('einstellungen.dialog.preislink')), 9, _hoisted_1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_FocusLock, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "headline font-weight-bold mb-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.titel')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pb-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          sm: "5",
                          class: "py-0"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('einstellungen.servicedialog.subtitel.basis')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "3",
                          class: "py-0 text-center"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.table.speicherplatz')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "py-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.table.kosten')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "py-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.table.kosten')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          sm: "6",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.table.basis')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "py-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.table.limit')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "py-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.table.monatrate')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "py-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.table.upgrade')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          sm: "6",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.locale === 'fr' ? _ctx.userServices.basisService.beschreibungFr : _ctx.userServices.basisService.beschreibungDe), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userServices.basisService.limiteGigaByte) + " GB", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userServices.basisService.preisProMonat.toFixed(2)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("0.00")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          sm: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('einstellungen.servicedialog.subtitle.speicher')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.checkNumberOfServices)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio_group, {
                              modelValue: _ctx.speicher,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.speicher) = $event)),
                              style: {"flex":"auto"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services.speicherServices, (row, index) => {
                                  return (_openBlock(), _createBlock(_component_v_row, { key: index }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        sm: "6",
                                        class: "py-1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_radio, {
                                            value: row.serviceId,
                                            label: _ctx.locale === 'fr' ? row.beschreibungFr : row.beschreibungDe
                                          }, null, 8, ["value", "label"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        sm: "2",
                                        class: "py-1 listvalues"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(row.limiteGigaByte) + " GB", 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        sm: "2",
                                        class: "py-1 listvalues"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(row.preisProMonat.toFixed(2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (_ctx.speicher === row.serviceId && _ctx.speicher === _ctx.userServices.speicherService?.serviceId)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            sm: "2",
                                            class: "py-1 listvalues"
                                          }, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                              _createTextVNode("0.00")
                                            ])),
                                            _: 1
                                          }))
                                        : (_ctx.speicher === row.serviceId)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 1,
                                              sm: "2",
                                              class: "py-1 listvalues"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(row.preisProRata.toFixed(2)), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : (_openBlock(), _createBlock(_component_v_col, {
                                              key: 2,
                                              sm: "2",
                                              class: "py-1 listvalues"
                                            }))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              sm: "12",
                              class: "py-1 pt-2 pb-0"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.speicher.empty')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          sm: "8",
                          class: "pt-8"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t('einstellungen.servicedialog.total')) + " ", 1),
                              (_ctx.userVerrechnung != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('einstellungen.servicedialog.totaldatumvon') +
                                            ' ' +
                                            _ctx.userVerrechnung.verrechnungVon +
                                            _ctx.$t('einstellungen.servicedialog.totaldatumbis') +
                                            ' ' +
                                            _ctx.userVerrechnung.verrechnungBis) + ") ", 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "pt-8"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.totalMonatKosten.toFixed(2)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          sm: "2",
                          class: "pt-8"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.totalRataKosten.toFixed(2)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "ml-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      type: "submit",
                      class: "modalbutton mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.save')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "modalbutton mb-3",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}